/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import WSButton from '../../../../../_metronic/helpers/components/WSButton/WSButton'
import {useState} from 'react'
import {useDispatch} from 'react-redux'
import {CreateApiKeysListOfuser} from './ApikeysSlices/ApiKeysSlices'

interface modalTypes {
  show: boolean
  handleClose: () => void
}

const CreateApiKeyModal = ({show, handleClose}: modalTypes) => {
  const dispatch = useDispatch()
  const [name, setName] = useState('')
  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px h-auto'
        show={show}
        onHide={handleClose}
      >
        <div className='scroll-x'>
          <div className='modal-header'>
            <h2 className='fs-2'>Create API Key</h2>
            <div className='btn btn-icon btn-sm' onClick={handleClose}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
            </div>
          </div>
          <div className='modal-body py-lg-5 px-lg-5 border-bottom'>
            <div className='mb-10 container'>
              <label className='form-label required'>API Name</label>
              <input
                data-testid='inputAPIName'
                onChange={(e: any) => setName(e.target.value)}
                type='text'
                className='form-control form-control-solid bg-light border-0'
                placeholder='Your API Name'
              />
            </div>

            <div className='container d-flex align-items-end justify-content-end mt-6 mb-5'>
              <WSButton
                type='submit'
                className='btn btn-lg btn-light-primary me-5 fw-500'
                onClick={handleClose}
              >
                <span className='indicator-label' data-testid='btnCancel'>Cancel</span>
              </WSButton>
              <WSButton
                disabled={name?.trim() == ''}
                type='submit'
                className='btn btn-lg btn-primary fw-500'
                onClick={() => {
                  dispatch(CreateApiKeysListOfuser(name?.trim()))
                  handleClose()
                }}
              >
                <span className='indicator-label' data-testid='btnSubmit'>Submit</span>
              </WSButton>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CreateApiKeyModal
